import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DataService } from '../../../core/data/data-service';
import { CommonService } from '../../../common/services/common.service';
import { AttractorLoopService } from '../../../core/routing/services/asset-library/attractor-loop.service';
import { GlobalConstants } from './../../../common/constants/global.constant';
import { AttractorLoop, AttractorLoopConfiguration } from './interfaces/attractor-loop.i';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../environments/environment';
import { Utils } from 'src/app/common/utils/utils';
import { LanguageConstants } from '../../header/constants/lang.consts';

@Component({
  selector: 'iposcen-attractor-loop',
  templateUrl: './attractor-loop.component.html',
  styleUrls: ['./attractor-loop.component.scss']
})
export class AttractorLoopComponent implements OnInit, OnDestroy {
  @ViewChild('deleteModal') deleteModal: ElementRef;
  userId = sessionStorage.getItem('userId');
  configurations: AttractorLoopConfiguration[];
  displayAttractorLoop = [];
  allAttractorLoop: AttractorLoop[];
  tabIndex = 0;
  labelY = GlobalConstants.YES;
  labelN = GlobalConstants.NO;
  // sideNav = 'store';
  sortValue = $localize`:@@attractor-loop.variable.create-date:Creation Date`;
  page = 1;
  pageSize = 5;
  internalName = GlobalConstants.INTERNAL_NAME;
  maxSize = 5;
  attractorLoopToDelete: string;
  attractorLoopToDeleteName: string;
  attractorLoopData: object;
  pageGrpForm: any;
  mediaObjects: any[] = [];
  deleteTooltipLabel = GlobalConstants.DELETE;
  editTooltipLabel = GlobalConstants.EDIT;
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  attractLoopVideoLabel = GlobalConstants.ATTRACT_LOOP_VIDEO_TEXT;
  createdDateVal = GlobalConstants.CREATED_DATE;
  groupNameVal = GlobalConstants.GROUP_NAME;
  globConstant = GlobalConstants;
  userRole: string = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  attractorLoopPreviewFlag: boolean = false;
  private ngUnsubscribe = new Subject<boolean>();
  constructor(
    private router: Router,
    private cmnService: CommonService,
    private dataService: DataService,
    private attractorLoopService: AttractorLoopService
  ) { }

  ngOnInit(): void {
    this.getAllAttractorLoopByUser();
    //IIT2-4663
    const pageName = this.router.url.lastIndexOf('/');
    if (this.router.url.substring(pageName + 1) === GlobalConstants.ASSET_LIBRARY) {
      this.attractorLoopPreviewFlag = true;
    }
    //this.cmnService.isFromAttractLoop = true;
  }

  // setSideNav(value: string) {
  //   this.sideNav = value;
  // }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getAllAttractorLoopByUser() {
    this.attractorLoopService.getAllAttractorLoopByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllAttractorLoopResponse => {
        this.allAttractorLoop = (getAllAttractorLoopResponse.attractLoop as AttractorLoop[]);
        this.configurations = [];
        this.allAttractorLoop.forEach(attractorLoopGroup => {
          try {
            this.configurations.push(JSON.parse(attractorLoopGroup.configurations) as AttractorLoopConfiguration);
          }
          catch (err) {
            console.log(err);
          }
        });

        // display Attractor loop using displayAttractorLoop var as configurations is coming as string
        this.displayAttractorLoop = [];
        this.allAttractorLoop.forEach(ele => {
          try {
            ele.configurations = JSON.parse(ele.configurations);
          }
          catch (err) {
            console.log(err);
          }
          ele.createdByUser = (ele.createdByUser === this.userId) ? GlobalConstants.ME : ele.createdByUser;
          this.displayAttractorLoop.push(ele);
        });
        this.displayAttractorLoop.forEach(element => {
          element.isExpanded = false;
          if (element.updateTime) {
            element.updateTime = new Date(element.updateTime);
          }
          if (element && element.configurations && element.configurations.formFactor) {
            element.configurations.formFactor = Utils.getFormFactorNames(element.configurations.formFactor);
          }
          if (element && element?.configurations) {
            if (element?.configurations?.publishTime && !element?.configurations?.isPublishDateNow) {
              // changing it to old format
              element.configurations.publishTime = Utils.ChangetoOldFormat(element?.configurations?.publishTime);
            }
            if (element?.configurations?.expireTime && element?.configurations?.expireTime !== GlobalConstants.NEVER) {
              // changing it to old format
              element.configurations.expireTime = Utils.ChangetoOldFormat(element?.configurations?.expireTime);
            }
            if (element?.configurations?.expireTime && element?.configurations?.expireTime === GlobalConstants.NEVER) {
              element.configurations.expireTime = LanguageConstants.NEVER;
            }
          }
          // For content expired notification
          element.isContentExpires = Utils.getExpiredContentdata(element);
        });
        this.sortByDate();
      },
        error => {
          // do something
        });
  }

  cancel() {
    this.dataService.setAttractorLoop(undefined);
    this.setIndex(0);
  }

  editAttractorLoop(attractorLoopID: string) {
    const attractorLoopToEdit = this.displayAttractorLoop.find(ele => ele.id === attractorLoopID);
    this.dataService.setAttractorLoop(attractorLoopToEdit);
    this.setIndex(1);
  }

  setIndex(value: number) {
    this.tabIndex = value;
  }

  /* Delete attrat loop content */
  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openDeleteModal(attractorLoopID: string) {
    this.attractorLoopToDelete = this.displayAttractorLoop.find(ele => ele.id === attractorLoopID).id;
    this.attractorLoopToDeleteName = this.displayAttractorLoop.find(ele => ele.id === attractorLoopID).configurations.publishedName;
    this.openModal(this.deleteModal);
  }

  deleteAttractorLoop(attractorLoopID: string) {
    this.attractorLoopService.deleteAttractorLoopById(attractorLoopID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(deleteResponse => {
        const index = this.displayAttractorLoop.findIndex(d => d.id === attractorLoopID); // find index in your array
        if (index >= 0) {
          this.displayAttractorLoop.splice(index, 1); // remove element from array
        }
        this.closeModal(this.deleteModal);
      },
        error => {
          // do something
          this.closeModal(this.deleteModal);
        });
  }
  loadMiniPreview(gId: string) {
    this.pageGrpForm = {
      bgcolor: '#ffffff',
      heading: ' ',
      hcolor: '#ffffff',
      body: ' ',
      bcolor: '#ffffff',
      size: GlobalConstants.MEDIUM,
      media: {
        url:
          environment.apiBaseUrlAsset +
          this.url +
          AssetLibraryConstants.ATTRACTOR_LOOP +
          AssetLibraryConstants.SLASH +
          gId,
        name: '',
        format: 'video',
        fileObj: ''
      },
      id: gId, // adding created group id,
      layout: 3
    };
    //IIT2-4663
    this.pageGrpForm.media.alMiniPreview = this.attractorLoopPreviewFlag ? true : false;

    return this.pageGrpForm;
  }

  setCreatedGrpID(data) {
    if (typeof data === 'object' && data.cancel) {
      this.setIndex(0);
    } else {
      this.attractorLoopData = data;
      this.setIndex(2);
    }
  }

  refreshAttractorLoopdata() {
    this.getAllAttractorLoopByUser();
    this.setIndex(0);
  }

  getDetailsOfAttractorLoop(id: string) {
    this.displayAttractorLoop.forEach(element => {
      if (element.id === id) {
        element.isExpanded = !element.isExpanded;
        this.cmnService.scrollToBottom(id);
      }
    });
  }

  sortByDate() {
    this.page = 1;
    this.sortValue = $localize`:@@attractor-loop.sort-by-date.created-date:Created Date`;
    this.displayAttractorLoop.sort((loop1, loop2) => loop2.updateTime - loop1.updateTime);

  }

  sortByName() {
    this.page = 1;
    this.sortValue = $localize`:@@attractor-loop.sort-by-name.group-name:Group Name`;
    this.displayAttractorLoop.sort((loop1, loop2) =>
      loop1.configurations.publishedName.localeCompare(loop2.configurations.publishedName));
  }

  createNewAttractLoop() {
    this.dataService.setAttractorLoop(undefined);
    this.tabIndex = 1;
  }
}
